module.exports = __webpack_public_path__ + "img/Vehicles.08bf357b.svg";